import { useState } from 'react';
import Drawer from '../Drawer/Drawer';
import StatusBadge from '../StatusBadge/StatusBadge';
import styles from './DisputeDrawer.module.css';

const DECISION_OPTIONS = [
  'Full refund to buyer',
  'Partial refund to buyer',
  'Release full amount to seller',
  'Split amount between parties',
];

export default function DisputeDrawer({ dispute, onClose, onResolve }) {
  const [decision, setDecision]       = useState('');
  const [amountBuyer, setAmountBuyer] = useState('');
  const [amountSeller, setAmountSeller] = useState('');
  const [notes, setNotes]             = useState('');

  const isSplit   = decision === 'Split amount between parties';
  const canResolve = decision && notes.trim() && (isSplit ? amountBuyer && amountSeller : true);

  function handleClose() {
    setDecision(''); setAmountBuyer(''); setAmountSeller(''); setNotes('');
    onClose();
  }

  function handleResolve() {
    if (!canResolve) return;
    onResolve({ decision, amountBuyer, amountSeller, notes });
    setDecision(''); setAmountBuyer(''); setAmountSeller(''); setNotes('');
  }

  const footer = dispute?.status === 'Open' ? (
    <button
      className={`${styles.btnResolve} ${canResolve ? styles.btnResolveActive : ''}`}
      onClick={handleResolve}
      disabled={!canResolve}
    >
      Resolve dispute
    </button>
  ) : null;

  return (
    <Drawer isOpen={!!dispute} title="Dispute details" onClose={handleClose} footer={footer}>
      {dispute && (
        <>
          {/* Dispute info */}
          <div className={styles.card}>
            <div className={styles.grid}>
              <div>
                <p className={styles.fieldLabel}>Order</p>
                <p className={styles.fieldValue}>{dispute.orderId}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Issue type</p>
                <p className={styles.fieldValue}>{dispute.type}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Reported By</p>
                <p className={styles.fieldValue}>{dispute.reportedBy}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Reported at</p>
                <p className={styles.fieldValue}>{dispute.reportedAt}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Amount involved</p>
                <p className={styles.fieldValue}>{dispute.amount}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Status</p>
                <StatusBadge status={dispute.status} />
              </div>
            </div>
          </div>

          {/* Order information */}
          <div className={styles.sectionTitle}>Order information</div>
          <div className={styles.card}>
            <div className={styles.grid}>
              <div>
                <p className={styles.fieldLabel}>Commodity</p>
                <p className={styles.fieldValue}>{dispute.commodity}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Seller</p>
                <p className={styles.fieldValue}>{dispute.seller}</p>
              </div>
              <div>
                <p className={styles.fieldLabel}>Transporter</p>
                <p className={styles.fieldValue}>{dispute.transporter}</p>
              </div>
            </div>
          </div>

          {/* Buyer's statement */}
          <div className={styles.sectionTitle}>Buyer's statement</div>
          <div className={styles.card}>
            <div className={styles.statementBody}>
              <p className={styles.statementText}>{dispute.statement}</p>
            </div>
          </div>

          {/* Evidence submitted */}
          <div className={styles.sectionTitle}>Evidence submitted</div>
          <div className={styles.card}>
            <div className={styles.evidenceBody}>
              {dispute.evidence.map((src, i) => (
                <img key={i} src={src} alt={`Evidence ${i + 1}`} className={styles.evidenceImg} />
              ))}
            </div>
          </div>

          {/* Resolution decision */}
          {dispute.status === 'Open' && (
            <>
              <div className={styles.sectionTitle}>Resolution decision</div>
              <div className={styles.card}>
                <div className={styles.resolutionBody}>
                  <div className={styles.field}>
                    <label className={styles.fieldLabel}>Decision</label>
                    <select
                      className={styles.select}
                      value={decision}
                      onChange={(e) => setDecision(e.target.value)}
                    >
                      <option value="">Select type</option>
                      {DECISION_OPTIONS.map((o) => (
                        <option key={o} value={o}>{o}</option>
                      ))}
                    </select>
                  </div>

                  {isSplit && (
                    <div className={styles.splitRow}>
                      <div className={styles.field}>
                        <label className={styles.fieldLabel}>Amount to buyer</label>
                        <input
                          type="text"
                          className={styles.input}
                          placeholder="R0"
                          value={amountBuyer}
                          onChange={(e) => setAmountBuyer(e.target.value)}
                        />
                      </div>
                      <div className={styles.field}>
                        <label className={styles.fieldLabel}>Amount to seller</label>
                        <input
                          type="text"
                          className={styles.input}
                          placeholder="R0"
                          value={amountSeller}
                          onChange={(e) => setAmountSeller(e.target.value)}
                        />
                      </div>
                    </div>
                  )}

                  <div className={styles.field}>
                    <label className={styles.fieldLabel}>Resolution notes</label>
                    <textarea
                      className={styles.textarea}
                      placeholder="Enter"
                      rows={4}
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </Drawer>
  );
}
